import { motion } from 'framer-motion';
import styled from 'styled-components';

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
`;

export const FloatingText = styled.div.attrs({ className: 'floating-text' })`
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 3;

  @media (max-width: ${({ theme }) => theme.mediaQuery.LARGE}) {
    && {
      position: static;
    }
  }

  @media (max-width: ${({ theme }) => theme.mediaQuery.MEDIUM}) {
    && {
      .info-text {
        max-width: 100%;
      }
    }
  }
`;

export const Illustrations = styled.div`
  width: 100%;
  position: relative;
`;

export const CellIllustration = styled(motion.div)`
  display: flex;
  align-items: flex-start;
  background: white;
  box-shadow: -1px 0px 0px rgba(2, 2, 27, 0.07),
    1px 0px 0px rgba(2, 2, 27, 0.07), 0px -1px 0px rgba(2, 2, 27, 0.07),
    0px 1px 0px rgba(2, 2, 27, 0.07), 0px 54px 74px rgba(1, 1, 27, 0.3),
    0px 14px 74px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  overflow: hidden;
  position: absolute;
  z-index: 2;

  img {
    flex: none;
  }
`;
